export const isNumeric = (value: string) => /^[+-]?\d+(\.\d+)?$/.test(value)
